import { AnimatePresence, motion } from 'framer-motion';

import { Chip } from '@/new/components/chip';
import { Icon } from '@/new/components/icon';
import { CHIP_COLOURS } from '@/new/lib/chip-colours';
import { cn } from '@/new/lib/utils';

export function CreateDocChronPreview({
  includeKeyFacts,
  includeRelevantFacts,
  includeAllFacts,
}: {
  includeKeyFacts: boolean;
  includeRelevantFacts: boolean;
  includeAllFacts: boolean;
}) {
  return (
    <div className="mt-7 flex h-56 items-center justify-center gap-2 overflow-hidden rounded-lg border bg-gray-50">
      <div className="relative w-3/4 shadow-lg/3">
        <div className="absolute -left-4.5 h-full w-px bg-gray-300 mask-t-from-80% mask-b-from-70%"></div>
        <div className="absolute top-7.25 -left-6 size-3.25 rounded-full border-2 border-teal-400 bg-teal-50"></div>

        <div className="relative z-10 flex h-23.5 flex-col gap-0.5 rounded-md border bg-white px-4 py-3 text-xs">
          <p className="text-[10px] text-blue-500">file.pdf</p>
          <p>22nd January 2010</p>
          <div className="mt-1 space-y-1.25">
            <div className="h-3 w-full rounded-sm bg-gray-200/60"></div>
            <div className="h-3 w-3/4 rounded-sm bg-gray-200/60"></div>
          </div>
        </div>
        <div
          className={`${includeKeyFacts || includeRelevantFacts || includeAllFacts ? 'h-18' : 'h-7'} relative -mt-1 flex w-full gap-2 overflow-x-clip rounded-b-lg bg-gray-200 p-2 pt-2.5 duration-150`}
        >
          <AnimatePresence mode="popLayout">
            {includeKeyFacts && (
              <motion.div
                key="keyfacts"
                layout
                transition={{ layout: { duration: 0.2 } }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { delay: 0.1, duration: 0.1 } }}
                exit={{ opacity: 0, transition: { delay: 0, duration: 0.1 } }}
                className="flex h-full w-36 shrink-0 flex-col gap-1.5 rounded-md border border-gray-300/70 bg-white p-2"
              >
                <Chip className={cn(CHIP_COLOURS.key, 'w-fit rounded border p-0.5 px-1.25 text-[10px]')}>
                  <Icon className="lucide--key-round" />
                  Key
                </Chip>
                <div className="h-3 rounded-sm bg-gray-200/60"></div>
              </motion.div>
            )}
            {includeRelevantFacts && (
              <motion.div
                key="relevantfacts"
                layout
                transition={{ layout: { duration: 0.2 } }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { delay: 0.1, duration: 0.1 } }}
                exit={{ opacity: 0, transition: { delay: 0, duration: 0.1 } }}
                className="flex h-full w-36 shrink-0 flex-col gap-1.5 rounded-md border border-gray-300/70 bg-white p-2"
              >
                <Chip className={cn(CHIP_COLOURS.relevance.relevant, 'w-fit rounded border p-0.5 px-1.25 text-[10px]')}>
                  Relevant
                </Chip>
                <div className="h-3 rounded-sm bg-gray-200/60"></div>
              </motion.div>
            )}
            {includeAllFacts && (
              <motion.div
                key="allfacts"
                layout
                transition={{ layout: { duration: 0.2 } }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { delay: 0.1, duration: 0.1 } }}
                exit={{ opacity: 0, transition: { delay: 0, duration: 0.1 } }}
                className="flex h-full w-36 shrink-0 flex-col gap-1.5 rounded-md border border-gray-300/70 bg-white p-2"
              >
                <Chip
                  className={cn(CHIP_COLOURS.relevance.notRelevant, 'w-fit rounded border p-0.5 px-1.25 text-[10px]')}
                >
                  Not Relevant
                </Chip>
                <div className="h-3 rounded-sm bg-gray-200/60"></div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
